import {Component, OnInit} from '@angular/core';

import {ModalService} from 'src/app/shared/services/modal.service';
import {ApiService} from 'src/app/shared/services/api.service';
import {UtilsService} from 'src/app/shared/services/utils.service';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {introSlider} from '../home/data';
import {SearchService} from '../../shared/services/search.service';

@Component({
    selector: 'indiapicture-ai-enquiry',
    templateUrl: './ai-enquiry.component.html',
    styleUrls: ['./ai-enquiry.component.scss']
})

export class AiEnquiryComponent implements OnInit {

    form: FormGroup;
    imagePreviews: string[] = [];


    products = [];
    posts = [];
    loaded = false;
    introSlider = introSlider;
    // introSlider1 = introSlider1;
    setting: any;
    slides = [];
    banners = [];
    noOfImages = 0;
    showText = 1;
    deals = [];
    categories = [];
    isMobile = false;
    offers = [];

    constructor(public apiService: ApiService, public utilsService: UtilsService, private modalService: ModalService,
                private searchService: SearchService, private fb: FormBuilder) {

        this.apiService.fetchSettings().subscribe(result => {
            this.setting = result.data;
            // console.log(this.setting);
            this.updateSetting();
            this.loaded = true;
        });
        this.searchService = SearchService.getInstance();
        this.searchService.setSearch('');
        this.searchService.setCategory('creative');
    }

    updateSetting() {
        this.slides = this.setting.home.slides.filter(item => item.published == 1);
        this.banners = this.setting.home.banners;
        this.offers = this.setting.offer;
        this.deals = this.setting.home.deals;
        this.categories = this.setting.home.categories;
        this.noOfImages = Number(this.setting.setting[0].title);
        // this.showText = this.setting.setting[0].published;
    }


    showModal(event: Event) {
        event.preventDefault();
        // console.log(event.currentTarget['href']);
        this.modalService.showVideoModal(event.currentTarget['href']);
    }

    ngOnInit() {
    this.form = this.fb.group({
        prompt: ['', Validators.required],
        referenceImage: [null],
        use: ['', Validators.required],
        name: ['', Validators.required],
        companyName: [''],
        email: ['', [Validators.required, Validators.email]],
        number: [''],
        uploadedImages: [[], Validators.required],
        imageLinks: this.fb.array([
            this.fb.control('', Validators.required),
            this.fb.control('', Validators.required)
        ])
    });
        if (window.innerWidth <= 500) {
            this.isMobile = true;
        }
    }


    // isMobile = false;
    // setting: any;
    // loaded = false;
    // slides = [];
    // introSlider = introSlider;
    //
    // constructor(public apiService: ApiService, public utilsService: UtilsService,
    //             private searchService: SearchService, private fb: FormBuilder)
    // {
    //     this.form = this.fb.group({
    //         prompt: ['', Validators.required],
    //         referenceImage: [null],
    //         use: ['', Validators.required],
    //         name: ['', Validators.required],
    //         companyName: [''],
    //         email: ['', [Validators.required, Validators.email]],
    //         number: [''],
    //         uploadedImages: [[], Validators.required],
    //         imageLinks: this.fb.array([
    //             this.fb.control('', Validators.required),
    //             this.fb.control('', Validators.required)
    //         ])
    //     });
    //     this.apiService.fetchSettings().subscribe(result => {
    //         this.setting = result.data;
    //      //  console.log(this.setting);
    //         this.updateSetting();
    //         this.loaded = true;
    //     });
    //     this.searchService = SearchService.getInstance();
    //     this.searchService.setSearch('');
    //     this.searchService.setCategory('creative');
    // }
    //
    // updateSetting() {
    //     this.slides = this.setting.home.slides.filter(item => item.published == 1);
    // }
    //
    //
    //
    // ngOnInit() {
    //     if (window.innerWidth <= 500) {
    //         this.isMobile = true;
    //     }
    //
    // }

    get imageLinks(): FormArray {
        return this.form.get('imageLinks') as FormArray;
    }
    onFileChange(event: Event): void {
        const target = event.target as HTMLInputElement;
        const files = target.files;
        if (!files) {
            return;
        }

        if (files.length > 5) {
            alert('You can upload a maximum of 5 images.');
            return;
        }

        const fileArray: File[] = [];
        this.imagePreviews = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            fileArray.push(file);

            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.imagePreviews.push(e.target.result);
            };
            reader.readAsDataURL(file);
        }

        this.form.get('uploadedImages')?.setValue(fileArray);
    }

    onSubmit(): void {
        if (this.form.valid) {
            // console.log(this.form.value);
            // You can send this to your backend
        } else {
            this.form.markAllAsTouched();
        }
    }

    onReferenceImageChange(event: Event):void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            this.form.get('referenceImage')?.setValue(file);
        }
    }


    getFormControl(control: any): FormControl {
        return control as FormControl;
    }
}
